var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pl-2"},[_c('div',{staticClass:"mr-2 mt-2 d-flex"},[_c('div',[_vm._v("New Ending: @")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.new_ending),expression:"new_ending"}],ref:"bemail-input",staticClass:"company-mail-endings-details-input",domProps:{"value":(_vm.new_ending)},on:{"input":function($event){if($event.target.composing)return;_vm.new_ending=$event.target.value}}})]),_c('v-btn',{staticClass:"mt-2",attrs:{"color":"green","disabled":_vm.is_submit_disabled},on:{"click":function($event){_vm.createUObject({
      url: [
        {businesses: _vm.business.id},
        {bemails: ''},
        {showWithEntitiesNormalized: ''}
      ],
      u_object: {
        value: _vm.new_ending
      },
      resp_data: {
        bemails: [
          {value: _vm.new_ending}
        ]
      }
      }).then(() => {
        _vm.new_ending = ''
        })}}},[_vm._v(" submit ")]),(_vm.is_submit_disabled)?_c('div',[_vm._v("error: "+_vm._s(_vm.is_submit_disabled))]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }